import { render, staticRenderFns } from "./DashboardManageUsers.vue?vue&type=template&id=e72fd958&scoped=true"
import script from "./DashboardManageUsers.vue?vue&type=script&lang=js"
export * from "./DashboardManageUsers.vue?vue&type=script&lang=js"
import style0 from "./DashboardManageUsers.vue?vue&type=style&index=0&id=e72fd958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72fd958",
  null
  
)

export default component.exports